module.exports = __webpack_public_path__ + "media/images/emblems/Besencens-Wappen-d28fc478505e21ce90bcbe8031c60b8a.png";